module.exports = __webpack_public_path__ + "img/钢铁厂.5231291c.png";